import React, { Fragment } from 'react'
import { graphql } from 'gatsby'

import { getProject } from '../../projects'
import {
  ProjectLayout,
  ProjectIntro,
  Title,
  Paragraph,
} from '../../layouts/project'

import { useNavbarTheme } from '../../contexts/NavbarTheme'

import { media } from '../../styles/tools'

import { AutoFade, AutoSlide } from '../../components/Animated'
import Wrapper from '../../components/Wrapper'
import Space from '../../components/Space'
import VideoPlayer from '../../components/VideoPlayer'

import Logo from '../../assets/pages/work/plum-lending/Logo.js'

export const query = graphql`
  {
    headerImage: file(relativePath: { eq: "pages/work/plum-lending.jpg" }) {
      ...windowWide
    }
    facebookImage: file(relativePath: { eq: "pages/work/plum-lending.jpg" }) {
      ...facebookShareImage
    }
    twitterImage: file(relativePath: { eq: "pages/work/plum-lending.jpg" }) {
      ...twitterShareImage
    }
  }
`

let project = getProject('plum-lending')

export default ({ data }) => {
  project = {
    ...project,
    headerImage: data.headerImage.childImageSharp.fluid,
    facebookImage: data.facebookImage.childImageSharp.fixed.src,
    twitterImage: data.twitterImage.childImageSharp.fixed.src,
    logo: <Logo />,
  }

  useNavbarTheme('dark')

  return (
    <ProjectLayout project={project}>
      <ProjectIntro
        project={project}
        text={
          <Fragment>
            <AutoFade>
              <Title as="h1" css={{ maxWidth: '11em' }}>
                Marketing to the new adventurers
              </Title>
            </AutoFade>
            <Space y={32} />
            <AutoFade>
              <Paragraph>
                Plum is for the new adventurers — the ones hungry to invest in
                something truly big, not just another food truck, YouTube
                channel, or messaging app. They've been there, done that, made
                their money, and now want to really make a mark.
              </Paragraph>
            </AutoFade>
            <Space y={16} />
            <AutoFade>
              <Paragraph>
                The new adventurers are also hardcore optimists — they have to
                be. They don't have the backing of private equity funds or
                family fortunes or foreign governments. They can't afford the
                usual "safe" deals in the usual megatropolis locations. (A
                high-rise hotel in Beverly Hills isn't even on their wish list.)
              </Paragraph>
            </AutoFade>
          </Fragment>
        }
      >
        <Space y={{ mobile: 60, tablet: 100 }} />
        Intro
      </ProjectIntro>
      <Wrapper>
        <Space y="25vw" />
        <Space y={{ mobile: 80, tablet: 150 }} />
        Content
      </Wrapper>
    </ProjectLayout>
  )
}
